import type { SVGProps } from 'react';

export function CurrencyIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#clip0_6180_13671)">
        <path
          d="M7.66667 1C3.98667 1 1 3.98667 1 7.66667C1 11.3467 3.98667 14.3333 7.66667 14.3333C11.3467 14.3333 14.3333 11.3467 14.3333 7.66667C14.3333 3.98667 11.3467 1 7.66667 1ZM8.25333 11.5067V11.7467C8.25333 12.0667 7.99333 12.3333 7.66667 12.3333C7.34667 12.3333 7.08 12.0733 7.08 11.7467V11.4667C6.66 11.3667 5.79333 11.06 5.28667 10.0667C5.13333 9.77333 5.28 9.40667 5.58667 9.28L5.63333 9.26C5.90667 9.14667 6.21333 9.26 6.35333 9.52C6.56667 9.92667 6.98667 10.4333 7.76667 10.4333C8.38667 10.4333 9.08667 10.1133 9.08667 9.36C9.08667 8.72 8.62 8.38667 7.56667 8.00667C6.83333 7.74667 5.33333 7.32 5.33333 5.8C5.33333 5.73333 5.34 4.2 7.08 3.82667V3.58667C7.08 3.26 7.34667 3 7.66667 3C7.98667 3 8.25333 3.26 8.25333 3.58667V3.83333C8.96667 3.96 9.42 4.34 9.69333 4.7C9.92 4.99333 9.8 5.42 9.45333 5.56667C9.21333 5.66667 8.93333 5.58667 8.77333 5.38C8.58667 5.12667 8.25333 4.86667 7.70667 4.86667C7.24 4.86667 6.5 5.11333 6.5 5.79333C6.5 6.42667 7.07333 6.66667 8.26 7.06C9.86 7.61333 10.2667 8.42667 10.2667 9.36C10.2667 11.1133 8.6 11.4467 8.25333 11.5067Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6180_13671">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
